import React from 'react';
import styles from './FormStyle.css.js';
import TextField from '@material-ui/core/TextField';
import { titleCase } from '../../utils/helpers';

const SearchInput = ({ value, handleChange, name }) => (
    <div style={styles.inputContainer}>
        <TextField
            id={`${name}-input-id`}
            label={name}
            variant='outlined'
            InputProps={{
                autoFocus: false,
                onChange: handleChange,
                value: titleCase(value)
            }}
            inputProps={{ 'aria-label': 'search-query-input' }}
            fullWidth
            style={styles.input}
        />
    </div>
);

export default SearchInput;